import Header from './components/Header';
import Hero from './components/Hero';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <ContactSection />
        <CommentsSection />
        <IndexSection />
        <AboutSection />
        <AppSection />
        <CarouselSection />
        <MediaSection />
        <TopicsSection />
        <FeaturesSection />
        <UpdatesSection />
        <RankingSection />
        <CardsSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}